<template>
  <div id="ProductManagement">
    <div class="row mb-3">
      <div class="col-sm-8">
        <h2>Manajemen Produk</h2>
      </div>
      <div class="col-sm-4 text-right">
        <b-link v-if="profileComplete" to="/add-product" class="mr-2">
          <b-button variant="primary" class="btn btn-custom theme-color px-4">Tambah
            Produk</b-button>
        </b-link>
        <b-button v-else variant="primary" class="btn btn-custom theme-color px-4"
          @click="notifyIncompleteProfile">
          Tambah Produk
        </b-button>
        <!-- <b-link to="/">
          <b-button variant="primary" class="btn btn-custom theme-color text-white px-4 rounded-0">Download</b-button>
        </b-link> -->
      </div>
    </div>

    <div class="row no-gutters mb-4">
      <div class="col-md-9">
        <label>Filter Berdasarkan Tanggal :</label>
        <div class="form-inline">
          <input name="start_date" type="text" onfocus="(this.type='date')" placeholder="Mulai Dari"
            class="form-control mr-2">
          <input name="end_date" type="text" onfocus="(this.type='date')" placeholder="Sampai Dengan"
            class="form-control mr-2">
          <b-button class="btn btn-custom btn-sm" @click="applyDateFilter">Filter</b-button>
        </div>
      </div>
    </div>
    <div class="row no-gutters mb-4">
      <div class="col-md-9">
        <div class="form-inline">
          <b-form-input v-model="filter" type="search" placeholder="Ketik untuk mencari .."></b-form-input>
          <b-button :disabled="!filter" @click="resetFilter"
            class="btn btn-custom theme-color ml-2">Reset</b-button>
        </div>
      </div>
    </div>

    <div class="overflow-auto">
      <b-table id="product-table" responsive class="table-scrollable" :items="items" :fields="fields"
        :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc">
        <!-- Menambahkan Indeks Berurutan -->
        <template v-slot:cell(id_produk)="data">
          {{ (currentPage - 1) * perPage + data.index + 1 }}
        </template>
        <template v-slot:cell(status)="data">
          <span :style="{ color: getStatusColor(data.item.status) }" class="font-weight-bold">
            {{ getStatusLabel(data.item.status) }}
          </span>
        </template>
        <template v-slot:cell(min_initial_deposit)="data">
          {{ formatCurrency(data.item.min_initial_deposit) }}
        </template>
        <template v-slot:cell(is_publish)="data">
          <template v-if="data.item.status !== 'pending' && data.item.status !== 'rejected'">
            <b-icon :icon="data.item.is_publish ? 'toggle-on' : 'toggle-off'" scale="2"
              :variant="data.item.is_publish ? 'success' : 'danger'" @click="changeStatus(data.item.id)"></b-icon>
          </template>
        </template>
        <template v-slot:cell(description)="data">
          <div>
            {{ shortenDescription(data.item.description) }}
            <b-link @click.prevent="viewFullDescription(data.item.description)">Lihat Lengkap</b-link>
          </div>
        </template>
        <template v-slot:cell(aksi)="data">
          <template v-if="data.item.status !== 'pending' && data.item.status !== 'rejected'">
            <b-link :to="{ name: 'EditProduct', params: { id: data.item.id } }">
              <b-icon icon="pencil" scale="2" class="mx-2" variant="primary"></b-icon>
            </b-link>
            <b-link @click="confirmDeleteProduct(data.item.id)">
              <b-icon icon="trash" scale="2" class="mx-2" variant="danger"></b-icon>
            </b-link>
          </template>
        </template>
      </b-table>

      <b-spinner v-if="!loaded" variant="warning" class="d-block mx-auto"></b-spinner>
      <b-pagination v-if="loaded" align="center" :total-rows="rows" :per-page="perPage" aria-controls="product-table"
        v-model="currentPage" hide-goto-end-buttons></b-pagination>
    </div>

    <b-modal size="sm" v-model="confirmDeleteModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Anda yakin ingin menghapus produk ini?</h3>
        <div class="row mt-4">
          <div class="col">
            <b-button block class="btn-custom success" @click="deleteProduct">Ya</b-button>
          </div>
          <div class="col">
            <b-button block class="btn-custom cancel" @click="cancelDeleteProduct">Tidak</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal size="l" v-model="modalDescription" hide-footer>
      <div class="d-block text-center">
        <h4>{{ modalText }}</h4>
        <div class="row mt-4">
          <div class="col">
            <b-button block @click="modalDescription = false" class="btn-custom success">Oke</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal size="sm" v-model="successDeleteModal" hide-footer hide-header>
      <div class="d-block text-center">
        <b-icon icon="exclamation-circle" class="mb-2" style="width: 120px; height: 120px;"></b-icon>
        <h3>Produk berhasil dihapus</h3>
        <b-button class="mt-3 btn-custom cancel" block @click="successDeleteModal = false">Tutup</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Product from '../../api/produk.js';

const fields = [
  { key: 'id_produk', label: 'No.', sortable: false },
  { key: 'nama_produk', label: 'Nama Produk', sortable: true },
  { key: 'sub_product_category.name', label: 'Kategori Produk', sortable: true },
  { key: 'description', label: 'Deskripsi' },
  { key: 'status', label: 'Status' },
  { key: 'min_initial_deposit', label: 'Setoran Awal' },
  { key: 'is_publish', label: 'Aktif' },
  { key: 'created_at', label: 'Created At', sortable: true },
  { key: 'aksi', label: 'Aksi' }
];

export default {
  name: "ManajemenProduk",
  data() {
    return {
      items: [],
      fields,
      perPage: 10,
      currentPage: 1,
      confirmDeleteModal: false,
      loaded: false,
      filter: '',
      successDeleteModal: false,
      sortBy: '',
      sortDesc: false,
      deleteProductId: null,
      modalText: '',
      modalDescription: false,
      profileComplete: false, // Status kelengkapan profil
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.checkProfileComplete();
    this.loadData();
  },
  methods: {
    checkProfileComplete() {
      Product.getIsFillMitraData()
        .then(res => {
          if (res.data.meta.code === 200) {
            this.profileComplete = true;
          } else {
            this.profileComplete = false;
          }
        })
        .catch(err => {
          console.error("Error checking profile completeness:", err);
          this.profileComplete = false;
        });
    },
    notifyIncompleteProfile() {
      this.$bvToast.toast('Silakan lengkapi profil Anda terlebih dahulu sebelum menambahkan produk.', {
        title: 'Profil Tidak Lengkap',
        variant: 'warning',
        solid: true,
        autoHideDelay: 5000,
      });
    },
    loadData() {
      Product.productOnMitra(this.currentUser.info.mitra_id)
        .then(res => {
          this.items = res.data.data.data;
          this.loaded = true;
        })
        .catch(err => console.error(err));
    },
    applyDateFilter() {
      // Implementasi filter berdasarkan tanggal
    },
    resetFilter() {
      this.filter = '';
    },
    shortenDescription(description) {
      if (!description) return '';
      return description.length > 20 ? description.slice(0, 20) + '...' : description;
    },
    viewFullDescription(description) {
      this.modalText = description;
      this.modalDescription = true;
    },
    formatCurrency(value) {
      if (!value) return 'Rp. 0';
      return 'Rp. ' + parseFloat(value).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    confirmDeleteProduct(id) {
      this.deleteProductId = id;
      this.confirmDeleteModal = true;
    },
    deleteProduct() {
      if (this.deleteProductId) {
        Product.delete(this.deleteProductId)
          .then(res => {
            if (res.data.meta.code === 200) {
              this.successDeleteModal = true;
              this.loadData();
            }
          })
          .catch(err => console.error(err));
        this.confirmDeleteModal = false;
      }
    },
    getStatusColor(status) {
      switch (status) {
        case 'pending':
          return 'orange'; // Warna untuk pending
        case 'approved':
          return 'green'; // Warna untuk approved
        case 'rejected':
          return 'red'; // Warna untuk rejected
        default:
          return 'black'; // Warna default
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case 'pending':
          return 'Menunggu Persetujuan'; // Label untuk pending
        case 'approved':
          return 'Disetujui'; // Label untuk approved
        case 'rejected':
          return 'Ditolak'; // Label untuk rejected
        default:
          return 'Status Tidak Diketahui'; // Label default
      }
    },
    cancelDeleteProduct() {
      this.confirmDeleteModal = false;
      this.deleteProductId = null;
    },
    changeStatus(id) {
      const data = { id };
      Product.changePublishStatus(data)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.loadData();
          }
        })
        .catch(err => console.error(err));
    }
  }
};
</script>

<style>
.table-scrollable {
  display: block;
  overflow-x: auto;
  /* Enable horizontal scrolling */
  white-space: nowrap;
  /* Prevent wrapping of table cells */
}

.table-scrollable table {
  min-width: 100%;
  /* Ensure table takes full width */
}

.small {
  max-width: 600px;
  margin: 150px auto;
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/manajemen-produk.vue